import MatterNotes from "@/components/features/matter/notes/MatterNotes";
import { AppModal } from "@/components/ui";
import type { Matter, MatterSubItemType } from "@/lib/types";

interface MatterSubItemNotesModalProps {
  entityLabel: string;
  matter: Matter;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  subItem: {
    id: string;
    type: MatterSubItemType;
  };
}

export const MatterSubItemNotesModal = ({
  entityLabel,
  matter,
  onOpenChange,
  open,
  subItem,
}: MatterSubItemNotesModalProps) => {
  return (
    <AppModal
      open={open}
      onOpenChange={onOpenChange}
      title={`Notes for ${entityLabel}`}
      size="3xl"
      bodyContained
    >
      <div className="flex h-[min(80vh,52rem)] min-h-0 flex-col p-4">
        <MatterNotes notes={[]} matter={matter} subItem={subItem} bareLayout />
      </div>
    </AppModal>
  );
};
